export default __webpack_public_path__ + "static/media/invoicelogo.911802b0.png";